import { DefaultButton, Stack } from "@fluentui/react";
import { Icon } from "@fluentui/react/lib/Icon";
import { useState } from "react";

import { Account } from "../../contract.interface";

import SignatureTable from "@/components/Contracts/DisplayContractInfo/ContractSignatures/SignatureTable";
import { DefaultCardTitle } from "@/components/Contracts/DisplayContractInfo/styles";
import { Card } from "@/components/Shared/Card";
import { ManageSignaturesModal } from "@/components/Shared/ManageSignaturesModal";
import { IDocumentEletronicSignature } from "@/modules/Terms/interfaces/ITerm.interface";

interface ContractSignaturesProps {
  contractId: number;
  eletronicSignature: IDocumentEletronicSignature;
  account: Account;
  businessUnitId: number;
  refetchContractData: () => Promise<void>;
}

export function ContractSignatures({
  contractId,
  eletronicSignature: electronicSignature,
  account,
  refetchContractData,
  businessUnitId
}: ContractSignaturesProps) {
  const [isManagementModalOpen, setIsManagementModalOpen] = useState(false);

  const apiConfig = {
    resendSignatureEndpoint: `contracts/${contractId}/resend-signatures`,
    updateSignatureEndpoint: `contracts/signature-method/${contractId}`
  };

  return (
    <Stack verticalFill>
      <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
        <DefaultCardTitle>
          <Icon iconName="OpenEnrollment" style={{ marginRight: 10 }} />
          Assinaturas
        </DefaultCardTitle>

        <DefaultButton onClick={() => setIsManagementModalOpen(true)}>
          Gerenciar
        </DefaultButton>
      </Stack>

      <Card borderRadius="1rem" padding="1rem">
        <SignatureTable signatures={electronicSignature} />
      </Card>

      <ManageSignaturesModal
        isOpen={isManagementModalOpen}
        onDismiss={() => setIsManagementModalOpen(false)}
        electronicSignature={electronicSignature}
        account={account}
        refetchData={refetchContractData}
        apiConfig={apiConfig}
        businessUnitId={businessUnitId}
      />
    </Stack>
  );
}
